export default __webpack_public_path__ + "static/moon_bunnies_a-ac71b3a9e2e42799214b234e50e1fe85.jpg";